import { volatileSum } from "~/utils/PriceUtils";
import { isTariffSurchargeEnabled } from "~/features/cart/cart/utils/cartUtils";
import type { CartEntrySummaryViewModel } from "~/features/cart/cartV2/models/ProductTableViewModel";
import type { ResolvedProductGroup } from "~/features/cart/cartV2/utils/selectResolvedGroupedEntryV2";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import { getTotalPriceForLineItem } from "~/domains/product/utils/productDescriptorUtils";

export function buildCartEntrySummary(
  resolvedGroup: Pick<ResolvedProductGroup, "lineItems">,
  hasLockedLines = false,
  productDescriptor: ProductDescriptor | null,
): CartEntrySummaryViewModel {
  const lineItems = resolvedGroup.lineItems;
  const lineItemCount = lineItems.length;
  const totalQuantity = lineItems.reduce((sum, item) => sum + item.quantity, 0);
  const subtotal =
    lineItems.length > 0
      ? volatileSum(
          ...lineItems.map((lineItem) =>
            getTotalPriceForLineItem(lineItem, productDescriptor?.base.quantityVisible ?? true),
          ),
        )
      : null;
  const surchargeEnabled = isTariffSurchargeEnabled();

  return {
    totalQuantity,
    lineItemCount,
    subtotal,
    hasTariffSurcharge: surchargeEnabled && lineItems.some((lineItem) => !!lineItem.netPrice?.tariffSurcharge),
    hasIncludedSurcharge: surchargeEnabled && lineItems.some((lineItem) => (lineItem.netPrice?.surcharge ?? 0) > 0),
    canDeleteProduct: !hasLockedLines,
  };
}
